// Data-driven pipeline diagram: every course gets the same instrument-style
// stage rail, differing only in its stage data. Pure SVG, scales to panel.
export default function CoursePipeline({ stages, label }) {
    const W = 960;
    const H = 132;
    const pad = 8;
    const gap = 26;
    const boxW = (W - pad * 2 - gap * (stages.length - 1)) / stages.length;
    const boxH = 84;
    const boxY = (H - boxH) / 2;

    return (
        <svg
            className="course-pipeline"
            viewBox={`0 0 ${W} ${H}`}
            role="img"
            aria-label={label}
        >
            {stages.map((stage, i) => {
                const x = pad + i * (boxW + gap);
                const cx = x + boxW / 2;
                return (
                    <g key={stage.label}>
                        <rect
                            className="course-pipeline-box"
                            x={x}
                            y={boxY}
                            width={boxW}
                            height={boxH}
                            rx={3}
                        />
                        <text className="course-pipeline-index" x={x + 10} y={boxY + 20}>
                            {String(i + 1).padStart(2, '0')}
                        </text>
                        <text className="course-pipeline-label" x={cx} y={boxY + 48} textAnchor="middle">
                            {stage.label}
                        </text>
                        {stage.sub && (
                            <text className="course-pipeline-sub" x={cx} y={boxY + 66} textAnchor="middle">
                                {stage.sub}
                            </text>
                        )}
                        {i < stages.length - 1 && (
                            <g className="course-pipeline-arrow" aria-hidden="true">
                                <line
                                    x1={x + boxW + 4}
                                    y1={H / 2}
                                    x2={x + boxW + gap - 4}
                                    y2={H / 2}
                                />
                                <path
                                    d={`M ${x + boxW + gap - 10} ${H / 2 - 5} L ${x + boxW + gap - 4} ${H / 2} L ${x + boxW + gap - 10} ${H / 2 + 5}`}
                                />
                            </g>
                        )}
                    </g>
                );
            })}
        </svg>
    );
}
